<template>
  <div class="employee_cla">
    <div class="margin-botton-cla">
      <el-input
        :placeholder="this.$t('common.searchValue')"
        v-model.trim="searchText"
        clearable
        @clear="clearChange"
        @keyup.enter.native="commQuery"
      >
        <el-button
          @click="commQuery"
          slot="append"
          icon="el-icon-search"
        ></el-button>
      </el-input>
    </div>

    <div class="margin-botton-cla">
      <el-button-group>
        <el-button
          @click="addEmployee"
          size="small"
          icon="el-icon-plus"
          :disabled="isAdmin"
          >{{ $t('employee.addEmployee') }}</el-button
        >

        <el-button @click="showDrawer"
          ><i class="el-icon-upload2"></i
          >{{ $t('empList.lostImport') }}</el-button
        >

        <el-button
          size="small"
          icon="el-icon-download"
          @click="exportTemplate"
          :disabled="pager.total === 0 ? true : false"
          >{{ $t('employee.exportEmployee') }}</el-button
        >
      </el-button-group>
    </div>

    <div>
      <el-table
        :data="tableData"
        @current-change="handleCurrentChange"
        highlight-current-row
        ref="employeeTable"
        style="width: 100%"
      >
        <el-table-column
          :label="this.$t('employee.employeeNo')"
          prop="employeeNo"
        ></el-table-column>
        <el-table-column
          :label="this.$t('employee.formattedName')"
          prop="formattedName"
        ></el-table-column>
        <el-table-column :label="this.$t('common.operation')">
          <template slot-scope="scope">
            <ZkButtonGroup
              :onlyShowText="true"
              :params="scope.row"
              @updateEmployee="updateEmployee"
              @deleteEmployee="deleteEmployee"
              size="mini"
              groupName="employeeBtnGroup"
              :isGroup="true"
            ></ZkButtonGroup>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-margin-top">
        <el-pagination
          background
          @size-change="changePageSize"
          @current-change="changePage"
          :current-page="pager.curPage"
          :page-size="pager.pageSize"
          layout="total, prev, pager, next"
          :total="pager.total"
          small
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50%"
      @close="handleClose"
      :rules="addRules"
    >
      <el-form
        label-position="right"
        label-width="140px"
        :model="empForm"
        ref="addForm"
        :rules="addRules"
      >
        <el-row :gutter="20" style="display: flex; flex-wrap: wrap">
          <el-col :span="12">
            <el-form-item
              :label="this.$t('employee.formattedName')"
              prop="name"
              class="formatted-name-cla"
            >
              <el-row>
                <el-col :span="11">
                  <el-form-item prop="lastName">
                    <el-input
                      v-model.trim="empForm.lastName"
                      :placeholder="this.$t('employee.reqLastName')"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-form-item prop="firstName">
                    <el-input
                      v-model.trim="empForm.firstName"
                      :placeholder="this.$t('employee.reqFirstName')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="this.$t('employee.employeeNo')"
              prop="employeeNo"
            >
              <el-input
                v-model.trim="empForm.employeeNo"
                :placeholder="this.$t('employee.reqEmployeeNo')"
                :disabled="isUpdate"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="this.$t('employee.email')" prop="email">
              <el-input
                v-model.trim="empForm.email"
                :placeholder="this.$t('user.inputEmail')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="this.$t('employee.gender')">
              <zk-dictionary-select
                type="sex"
                v-model="empForm.gender"
                clearable
                style="width: 100%"
              ></zk-dictionary-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item :label="this.$t('employee.phone')" prop="phone">
              <el-input
                v-model.trim="empForm.phone"
                :placeholder="this.$t('developer.phonePla')"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="this.$t('employee.hireDate')">
              <el-date-picker
                v-model="empForm.hireDate"
                type="date"
                :placeholder="this.$t('common.selectDate')"
                style="width: 100%"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('user.department')" prop="organization">
              <el-tree
                ref="deptTree"
                :data="orgTreeDisable"
                :props="defaultProps"
                :show-checkbox="true"
                node-key="organizationCode"
                @check-change="getChecked"
                :default-checked-keys="deptArr"
                :default-expanded-keys="deptArr"
                :check-strictly="true"
              ></el-tree>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="sumbitAddEmployer">{{
          $t('common.confirm')
        }}</el-button>
      </span>
    </el-dialog>

    <el-drawer
      :title="this.$t('empList.lostImport')"
      :visible.sync="drawer"
      direction="rtl"
      :before-close="handleDrawerClose"
      ref="drawer"
      :append-to-body="true"
    >
      <div class="demo-drawer__content">
        <div style="position: relative" v-if="!isFinishUpload">
          <el-upload
            ref="uploadExcel"
            action="/apiv1/hr/employee/uploadExcel"
            :on-success="handleSuccess"
            :on-error="handleError"
            :data="datas"
            style="display: inline-block"
            :disabled="isAdmin"
            :before-upload="beforeAvatarUpload"
            :auto-upload="false"
            :multiple="false"
          >
            <el-button
              size="small"
              icon="el-icon-upload2"
              type="primary"
              :disabled="isAdmin"
            >
              {{ $t('empList.choiseFile') }}
            </el-button>
          </el-upload>
          <span style="position: absolute; top: 5px">{{
            $t('empList.extName')
          }}</span>
          <div style="position: absolute; top: 5px; right: 0">
            <a
              :href="url"
              style="float: left; text-decoration: none; color: #7ac413"
            >
              {{ $t('employee.downloadTemplate') }}
            </a>
          </div>
        </div>

        <div v-else>
          <p>{{ $t('empList.finishImport') }}</p>
          <span :style="'color:' + result.color">{{ result.message }}</span>
        </div>
        <div class="demo-drawer__footer">
          <div v-if="!isFinishUpload">
            <el-button type="primary" @click="importTemplate">{{
              $t('empList.beginImport')
            }}</el-button>

            <el-button @click="handleDrawerClose">{{
              $t('common.cancel')
            }}</el-button>
          </div>
          <el-button type="primary" v-else @click="finishUpload">{{
            $t('empList.finish')
          }}</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getDeptEmployeeList,
  addEmployee,
  removeEmployee,
  updateEmployee,
  getDownLoadTemplate
} from '@/services/employeeApi.js'
import {
  validatorEmailRule,
  validatorPhoneRule,
  validatorInputEmptyRule
} from '@/utils/validatorRule.js'
import { getLanguage } from '@/utils/utils.js'
export default {
  data() {
    let checkNo = (rules, value, callback) => {
      let letterNum = /^[A-Za-z0-9]+$/
      let num = /^[0-9]+$/
      if (letterNum.test(value) || num.test(value)) {
        return callback()
      } else {
        return callback(new Error(window.vm.$t('common.employeeNoTips')))
      }
    }
    return {
      tableData: [],
      currentRow: null,
      searchText: '',
      dialogVisible: false,
      empForm: {
        companyId: '', //
        employeeNo: '', //
        name: {
          lastName: '',
          firstName: ''
        },
        lastName: '',
        firstName: '',
        formattedName: '',
        gender: '',
        email: '',
        phone: '',
        hireDate: '',
        organization: [], // 左边先选择
        devicePermission: '',
        deviceVerifyMode: '',
        devicePassword: '',
        cardNo: ''
      },
      addRules: {
        name: [{ required: true }],
        lastName: validatorInputEmptyRule(true, 32),
        firstName: validatorInputEmptyRule(true, 32),
        employeeNo: validatorInputEmptyRule(true, 9, checkNo),
        email: validatorEmailRule(false),
        phone: validatorPhoneRule(false)
      },
      devicePermission: [
        { label: this.$t('devicePermission.0'), value: '0' },
        { label: this.$t('devicePermission.14'), value: '1' }
      ],
      verifyintModel: [],
      title: this.$t('employee.addEmployee'),
      isUpdate: false,
      treeData: [],
      defaultProps: {
        children: 'children',
        label: 'organizationName'
      },
      deptArr: [],
      tempData: [],
      datas: {
        companyId: ''
      },
      url: '',
      drawer: false,
      isFinishUpload: false,
      result: {
        color: '',
        msg: ''
      },
      row: []
    }
  },
  computed: {
    isAdmin() {
      return sessionStorage.getItem('loginName') === 'admin'
    },
    orgTreeDisable() {
      this.orgTree.forEach(item => {
        item.disabled = true
      })
      return this.orgTree
    }
  },
  props: {
    currentOrg: {
      type: Object,
      default: function() {
        return {}
      }
    },
    orgTree: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  watch: {
    'currentOrg.id': {
      handler: function(val, oVal) {
        if (val) {
          this.getEmployeeList(val)
          this.pager.curPage = 1
        } else {
          this.getEmployeeList('')
        }
      },
      deep: true
    }
  },
  created() {
    this.getDownloadTemplate()
  },
  mounted() {
    if (this.currentOrg.id) {
      this.getEmployeeList(this.currentOrg.id)
    } else {
      // this.getEmployeeList('', '')
    }
  },
  methods: {
    beforeAvatarUpload(file) {
      const type = [
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ] // .xls .xlsx
      const isXLSL = type.includes(file.type)
      if (!isXLSL) {
        this.$message.error(this.$t('empList.onlyXLSL'))
        return false
      }
      return isXLSL
    },
    showDrawer() {
      this.drawer = true
    },
    handleDrawerClose() {
      this.drawer = false
    },

    // 获取模板下载地址
    getDownloadTemplate() {
      getDownLoadTemplate()
        .then(data => {
          if (data.code === '00000000') {
            this.url = data.payload.results
          }
        })
        .catch(e => {})
    },

    // 导入失败
    handleError(err) {
      this.$message.error(err)
    },
    // 上传成功 接口返回
    handleSuccess(data) {
      this.isFinishUpload = true
      if (data.code === '00000000') {
        this.result = {
          color: '@themeColor',
          message: this.$t('operationMsg.importSuc')
        }
      } else {
        this.result = {
          color: '#f56c6c',
          message: data.message
        }
      }
    },

    // 完成上传
    finishUpload() {
      this.drawer = false
      this.isFinishUpload = false
      this.getEmployeeList(this.currentOrg.id)
    },

    // 触发提交上传事件
    importTemplate() {
      this.datas.companyId = sessionStorage.getItem('companyId')
      this.$refs.uploadExcel.submit()
    },

    // 导出员工
    exportTemplate() {
      let companyId = sessionStorage.getItem('companyId')
      let lang = getLanguage()
      window.open(
        `/apiv1/hr/employee/exportExcel?companyId=${companyId}&lang=${lang}`
      )
    },

    // tree单选
    getChecked(data, checked, indeterminate) {
      let r = this.$refs.deptTree.getCheckedNodes()
      this.tempData = []
      this.empForm.organization = []
      r.forEach(item => {
        this.tempData.push(item.organizationCode)
      })
    },

    updateEmployee(row) {
      this.title = this.$t('employee.updateEmployee')
      this.row = row
      this.isUpdate = true
      this.dialogVisible = true
      this.empForm.lastName = row.lastName
      this.empForm.firstName = row.firstName
      this.empForm.gender = row.gender
      this.empForm.email = this.emailFormat(row.email)
      this.empForm.phone = this.phoneFormat(row.phone)
      this.empForm.hireDate = row.hireDate
      this.empForm.employeeNo = row.employeeNo
      // this.empForm = JSON.parse(JSON.stringify(row))
      this.empForm.email = this.emailFormat(row.email)
      this.empForm.phone = this.phoneFormat(row.phone)
      this.empForm.name.firstName = row.firstName
      this.empForm.name.lastName = row.lastName
      this.deptArr = []
      this.deptArr = row.organization
    },

    // 添加员工  没选择部门
    addEmployee() {
      if (!this.currentOrg.organizationCode) {
        this.$notify({
          title: this.$t('common.warningNotice'),
          message: this.$t('employee.selectOrgTip'),
          type: 'warning'
        })
        return
      }
      this.dialogVisible = true
      this.title = this.$t('employee.addEmployee')
      this.isUpdate = false
      this.deptArr = []
      this.deptArr.push(this.currentOrg.organizationCode)
    },

    deleteEmployee(row) {
      this.$confirm(
        this.$t('employee.deleteEmployee'),
        this.$t('common.warningNotice'),
        {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }
      )
        .then(() => {
          let params = {
            companyId: row.companyId,
            employeeNo: row.employeeNo
          }
          removeEmployee(params)
            .then(data => {
              if (data.code === '00000000') {
                this.$message.success(data.message)
                this.getEmployeeList(this.currentOrg.id)
              } else {
                this.$message.error(data.message)
              }
            })
            .catch(e => {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('common.cancelDelete')
          })
        })
    },

    // 提交员工信息 名字区分中英文
    sumbitAddEmployer() {
      this.empForm.formattedName =
        this.empForm.lastName + this.empForm.firstName
      if (/^[a-zA-Z]*$/.test(this.empForm.formattedName)) {
        this.empForm.formattedName =
          this.empForm.firstName + '.' + this.empForm.lastName
      } else if (/^[\u4e00-\u9fa5]*$/.test(this.empForm.formattedName)) {
        this.empForm.formattedName =
          this.empForm.lastName + this.empForm.firstName
      }
      // this.empForm.deviceVerifyMode = this.empForm.deviceVerifyMode.toString()
      this.empForm.organization = [] // fix 新增已存员工修改后 提交报组织架构不存在
      if (this.tempData && this.tempData.length === 0) {
        this.empForm.organization.push(this.currentOrg.organizationCode)
      } else {
        this.empForm.organization = this.tempData
      }

      this.empForm.companyId = this.currentOrg.companyId
      this.$refs.addForm.validate(valid => {
        if (valid) {
          if (this.isUpdate) {
            updateEmployee(this.empForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(data.message)
                  this.getEmployeeList(this.currentOrg.id)
                  this.handleClose()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch(e => {})
          } else {
            addEmployee(this.empForm)
              .then(data => {
                if (data.code === '00000000') {
                  this.$message.success(data.message)
                  this.getEmployeeList(this.currentOrg.id)
                  this.handleClose()
                } else {
                  this.$message.error(data.message)
                }
              })
              .catch(e => {
                console.log(e)
              })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    setCurrent(row) {
      this.$refs.employeeTable.setCurrentRow(row)
    },
    getEmployeeList(id, searchText) {
      let param = {
        organizationId: this.currentOrg.id
      }
      if (searchText) {
        param.searchText = searchText
      }
      let params = {
        params: param,
        pager: this.pager
      }
      getDeptEmployeeList(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.results
            if (this.tableData.length > 0) {
              this.setCurrent(this.tableData[0])
            }

            // this.page.pageSize = data.payload.pageSize
            // this.pager.curPage = data.payload.curPage
            this.pager.total = data.payload.totalRecords
          } else {
            this.tableData = []
            this.setCurrent(null)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    },
    handleClose() {
      this.dialogVisible = false
      this.empForm.companyId = '' //
      this.empForm.employeeNo = '' //
      this.empForm.lastName = ''
      this.empForm.firstName = ''
      this.empForm.formattedName = ''
      this.empForm.gender = ''
      this.empForm.email = ''
      this.empForm.phone = ''
      this.empForm.hireDate = ''
      this.empForm.organization = [] // 左边先选择
      this.empForm.devicePermission = ''
      this.empForm.deviceVerifyMode = ''
      this.empForm.devicePassword = ''
      this.empForm.cardNo = ''
      this.isUpdate = false
      this.deptArr = []
      this.$refs.deptTree.setCheckedKeys([])
      if (this.$refs.addForm) {
        this.$refs.addForm.resetFields()
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val
      this.$emit('selectCurrentRow', val)
    },
    commQuery() {
      this.getEmployeeList('', this.searchText)
    },
    clearChange() {
      if (this.currentOrg.id) {
        this.getEmployeeList(this.currentOrg.id, '')
      } else {
        this.getEmployeeList('', '')
      }
    }
  }
}
</script>

<style scoped lang="less">
.formatted-name-cla {
  /deep/ .el-form-item--small {
    margin-bottom: 0px;
  }
}
.line_cla {
  width: 100%;
  height: 460px;
  border-right: 1px solid #e1e3e6;
  position: relative;
  &::after {
    content: '';
    position: absolute;
    top: 50px;
    right: -1px;
    width: 0;
    height: 0;
    border-width: 8px;
    border-style: solid;
    border-color: transparent #e1e3e6 transparent transparent;
  }
  span {
    display: block;
    width: 0;
    height: 0;
    border-right: 8px solid #fff;
    border-bottom: 8px solid transparent;
    border-left: 8px solid transparent;
    border-top: 8px solid transparent;
    position: absolute;
    right: -3px;
    top: 50px;
    z-index: 99;
  }
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  &:nth-child(2) {
    margin: 0 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/enterpriseSetting/employee/employeeList.vue